import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setup } from './telemetry';
import './index.css';

const version = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'dev';
setup(import.meta.env.DEV ? 'development' : 'production', version);

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>
);
